import { Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AxiosError } from 'axios';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PayeePopupComponent } from '../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-delete-client-access-dialog',
  templateUrl: './delete-client-access-dialog.component.html',
  styleUrls: ['./delete-client-access-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class DeleteClientAccessDialogComponent {
  private clientsService = inject(ClientsService);
  private snackbar = inject(MatSnackBar);
  private translate = inject(TranslateService);
  dialogRef =
    inject<MatDialogRef<DeleteClientAccessDialogComponent>>(MatDialogRef);
  client = inject<SelectedClient>(MAT_DIALOG_DATA);

  submitLoading = false;

  async submit(): Promise<void> {
    if (this.submitLoading) {
      return;
    }

    try {
      this.submitLoading = true;
      await this.clientsService.deleteClientAccess(this.client.id);
      this.dialogRef.close(true);
      this.snackbar.open(
        this.translate.instant('CLIENT_ACCESS.DELETE.SUCCESS'),
        this.translate.instant('OK'),
        { duration: 3000 },
      );
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 422) {
          const errorCode = error.response.data?.code;

          if (errorCode === 'last-client') {
            this.snackbar.open(
              this.translate.instant('CLIENT_ACCESS.DELETE.ERROR_LAST'),
              this.translate.instant('OK'),
              { duration: 5000 },
            );
            return;
          }
        }
      }
      console.error('Error while deleting client access', error);
      this.snackbar.open(
        this.translate.instant('ERROR_MESSAGES.UNKNOWN_ERROR'),
        this.translate.instant('OK'),
        { duration: 5000 },
      );
    } finally {
      this.submitLoading = false;
    }
  }
}
